import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangelogService } from './services/changelog.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [ChangelogService],
  exports: [],
})
export class ChangelogModule {}
